// extracted by mini-css-extract-plugin
export default {"clue":"Clue_clue__ZLMLY","key":"Clue_key__9COZv"};